import { render } from "./trademark-faqs.vue?vue&type=template&id=32a74526&scoped=true"
import script from "./trademark-faqs.vue?vue&type=script&lang=js"
export * from "./trademark-faqs.vue?vue&type=script&lang=js"

import "./trademark-faqs.vue?vue&type=style&index=0&id=32a74526&lang=css"
import "./trademark-faqs.vue?vue&type=style&index=1&id=32a74526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a74526"]])

export default __exports__